export const openSteps = [
  {
    id: 1,
    icon: "ri-inbox-archive-line",
    title: "把快递盒放到平整桌面",
    desc: "先看外包装是否完好，拍一张封面照记录批次与到货时间，方便之后回看。",
  },
  {
    id: 2,
    icon: "ri-scissors-cut-line",
    title: "沿封口边轻轻划开",
    desc: "不要直接剪到内部，沿着胶带边缘走刀，能尽量保留盒子本身的图案与结构。",
  },
  {
    id: 3,
    icon: "ri-layout-grid-line",
    title: "按类别摊开再逐个拆袋",
    desc: "先按甜口、咸香、辣味等分类摆放，避免混在一起后忘记具体口味和数量。",
  },
  {
    id: 4,
    icon: "ri-edit-2-line",
    title: "边拆边记录试吃感受",
    desc: "趁味觉还新鲜写下香气、口感与惊喜点，配上照片，形成这一期的开箱记录。",
  },
];

export const heroStats = [
  { label: "累计开箱", value: "328", unit: "盒" },
  { label: "试吃单品", value: "146", unit: "款" },
  { label: "本周新入", value: "12", unit: "款" },
];

export const luckyBoxes = [
  "黑糖脏脏包",
  "川香麻辣锅巴",
  "海盐焦糖曲奇",
  "蜂蜜黄油杏仁",
  "藤椒味薯片",
  "咸蛋黄酥",
  "炭烤腰果",
  "抹茶麻薯",
  "陈皮话梅",
  "童年麦丽素",
];